import clsx from 'clsx';
import { FC, useEffect, useState } from 'react';

import styles from './sign-up-page.module.scss';
import { ISignUpPageProps } from './types';

import { SignUp } from '../../components';

import { getSignInBg } from '~utils';

export const SignUpPage: FC<ISignUpPageProps> = ({ className = '', ...rest }) => {
  const [bgImage, setBgImage] = useState<string | null>(null);

  useEffect(() => {
    getSignInBg()
      .then(res => {
        setBgImage(res.data?.link ?? null);
      })
      .catch(err => {
        console.log(err);
      });
  }, []);

  return (
    <section
      className={clsx(styles.container, className)}
      style={{ ...(bgImage && { backgroundImage: `url(${bgImage})` }) }}
      {...rest}
    >
      <SignUp className={styles.form} />
    </section>
  );
};
